import React from "react";
import { occupancyTone } from "../utils/occupancy";

/** Occupancy in percent: colored number, bar and a word (color is not the only carrier of information). */
export default function OccupancyMeter({ pct, className = "" }) {
  const v = Math.max(0, Math.min(100, Number(pct) || 0));
  const tone = occupancyTone(v);
  return (
    <div className={`min-w-0 ${className}`} data-tone={tone.key}>
      <div className="flex items-baseline gap-1.5 tabular-nums">
        <span className={`text-base font-semibold ${tone.text}`}>{v.toFixed(0)}%</span>
        <span className={`text-xs ${tone.text}`}>{tone.word}</span>
      </div>
      <div
        role="progressbar"
        aria-label="Zauzetost"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(v)}
        className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800"
      >
        <div className={`h-full rounded-full transition-[width] duration-300 ${tone.fill}`} style={{ width: `${v}%` }} />
      </div>
    </div>
  );
}
